import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Common Pages
import Header from './components/Header';
import HeroSection from './components/Herosection';
import About from './components/About';
import Service from './components/Service';
import Sector from './components/Sector';
import Footer from './components/Footer';
import Aboutpg from './components/Aboutpg';
import Servicepg from './components/Servicepg';
import Servicehero from './components/Servicehero';
import ContactPage from './components/Contactpage';
import Contacthero from './components/Contacthero';
import Mission from './components/Mission';
import Methodology from './components/Methodology';

// Service Pages
import Engineeringdesign from './components/Engineeringdesign';
import Testingcommissioning from './components/Testingcommissioning';
// import Equipmentrental from './components/Equipmentrental';
// import Skilledmanpower from './components/Skilledmanpower';
// import Oilfiltration from './components/Oilfiltration';
import Maintenanceservices from './components/Maintenanceservices';

// Rental Pages
// import Rental from './components/Rental';
// import Selectrental from './components/Selectrental';

// New Pages
import Mechpg from './components/Mechpg';
import Civilpg from './components/Civilpg';

// Loader
import Loader from './components/Loader';
import Mechhero from './components/Mechhero';
import MechheroExtra from './components/MechheroExtra';
import Civilhero from './components/Civilhero';
import CivilheroExtra from './components/CivilheroExtra';

function Home() {
  return (
    <>
      <Header />
      <HeroSection />
      <Sector />
      <Service />
      <Footer />
    </>
  );
}

function Abouts() {
  return (
    <>
      <Header />
      <Aboutpg />
      <About />
      <Mission />
      <Footer />
    </>
  );
}

function ServicePage() {
  return (
    <>
      <Header />
      <Servicepg />
      <Servicehero />
      <Methodology />
      <Service />
      <Footer />
    </>
  );
}
function Mechpage(){
  return(
    <>
    <Header />
    <Mechpg />
    <Mechhero />
    <MechheroExtra />
    <Footer />
    </>
  )
}
function Civilpage(){
  return(
    <>
    <Header />
    <Civilpg />
    <Civilhero />
    <CivilheroExtra />
    <Footer />
    </>
  )
}


function ContactPg() {
  return (
    <>
      <Header />
      <ContactPage />
      <Contacthero />
      <Footer />
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Router>
      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Abouts />} />
        <Route path="/servicepg" element={<ServicePage />} />
        <Route path="/contactpg" element={<ContactPg />} />

        {/* New Pages */}
        <Route path="/mechpg" element={<Mechpage />} />
        <Route path="/civilpg" element={<Civilpage />} />

        {/* Service Detail Pages */}
        <Route path="/services/service1" element={<Engineeringdesign />} />
        <Route path="/services/service2" element={<Testingcommissioning />} />
        {/* <Route path="/services/service3" element={<Equipmentrental />} />
        <Route path="/services/service4" element={<Skilledmanpower />} />
        <Route path="/services/service5" element={<Oilfiltration />} /> */}
        <Route path="/services/service6" element={<Maintenanceservices />} />

        {/* Rental Pages */}
        {/* <Route path="/rental" element={<Rental />} />
        <Route path="/select-rental/:model" element={<Selectrental />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
